"use client"

import { FutureDevelopmentPlaceholder } from "features/common/ui/FutureDevelopmentPlaceholder"
import { PlanInfo } from "features/team/ui/plan/PlanInfo"
import { useLocation, useNavigate } from "react-router-dom"
import { Tabs, TabsProps } from "shared/ui"
import { getUserRole } from "features/user/model/selectors/userSelectors"
import { useAppSelector } from "shared/config/store"
import { MemberRole } from "features/team/model/types/members"
import { hasAccess } from "shared/utils"

import { ManageMembers } from "../../team/ui/members/ManageMembers"

import { Account } from './Account'

interface TabItemWithPath {
  label: string
  children: React.ReactNode
  path: string
  key?: string
}


export const ProfileTabMenu = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const userRole = useAppSelector(getUserRole)

  const TAB_CONFIG: TabItemWithPath[] = [
    {
      label: 'Manage members',
      children: <ManageMembers />,
      path: '/profile/manage-members',
    },
    {
      label: 'Account',
      children: <Account />,
      path: '/profile/account',
    },
    {
      label: 'Field',
      children: <FutureDevelopmentPlaceholder />,
      path: '/profile/field',
    },
    {
      label: 'Tags',
      children: <FutureDevelopmentPlaceholder />,
      path: '/profile/tags',
    },
    hasAccess(userRole, [MemberRole.ADMIN, MemberRole.OWNER]) && {
      label: 'Plan',
      children: <PlanInfo />,
      path: '/profile/plan',
    },
    {
      label: 'Invoice',
      children: <FutureDevelopmentPlaceholder />,
      path: '/profile/invoice',
    },
    {
      label: 'Security',
      children: <FutureDevelopmentPlaceholder />,
      path: '/profile/security',
    },
  ].filter(Boolean)
  
  const tabItems: TabsProps['items'] = TAB_CONFIG.map((item, index) => ({
    ...item,
    key: String(index + 1),
  }))
  
  const PATH_TO_KEY_MAP = Object.fromEntries(
    TAB_CONFIG.map((item, index) => [item.path, String(index + 1)])
  )
  
  const KEY_TO_PATH_MAP = Object.fromEntries(
    TAB_CONFIG.map((item, index) => [String(index + 1), item.path])
  )

  const pathname = location.pathname
  const activeKey = PATH_TO_KEY_MAP[pathname] || "1"

  const handleTabChange = (key: string) => {
    const path = KEY_TO_PATH_MAP[key]
    if (path) {
      navigate(path)
    }
  }

  return (
    <Tabs
      activeKey={activeKey}
      items={tabItems}
      onChange={handleTabChange}
      destroyInactiveTabPane={true}
    />
  )
}



